<template>
    <div class="main-body">
        <h2>{{ $strings('cpsite/send/title') }}</h2>
        <el-row :gutter="10">
            <el-col :span="8">
                <el-card shadow="never" class="card-min">
                    <el-form label-position="top" label-width="80px" :model="createForm">
                        <el-form-item>
                            <h4 slot="label">Template</h4>
                            <el-card shadow="never" class="card-min">
                                <div slot="header" class="clearfix" style="line-height:20px;">
                                    <span>{{ chooseTplIs.tpl_name }}</span>
                                    <el-button style="float: right; padding: 3px 0" type="text"
                                               @click="dialogVisible=true">Change
                                    </el-button>
                                </div>
                                <div class="tpl-body">{{ chooseTplIs.tpl_content }}</div>
                            </el-card>
                            <el-row>
                                <el-col :span="8">
                                    <el-checkbox v-model="createForm.is_unicode">Unicode</el-checkbox>
                                    <el-checkbox v-model="createForm.is_flash">Flash</el-checkbox>
                                </el-col>
                                <el-col :span="16" class="count-area">
                                    <span :class="highlightOverflow()">{{ countContent() }}</span> /
                                    <span>70</span>
                                </el-col>
                            </el-row>

                        </el-form-item>
                        <el-form-item>
                            <h4 slot="label" v-if="vars.length > 0">Variable</h4>
                            <el-input placeholder="" v-model="values[item]" @input="replaceContent(item)"
                                      v-for="(item,idx) in vars" :key="idx">
                                <template slot="prepend"><span>{{ item }}</span></template>
                            </el-input>
                        </el-form-item>
                    </el-form>
                </el-card>
            </el-col>
            <el-col :span="16">
                <el-card shadow="never" class="card-min">
                    <el-form label-position="top" label-width="80px" :model="createForm">
                        <el-form-item label="Step1: Campaign name">
                            <h4 slot="label">Step1: Campaign name</h4>
                            <el-input v-model="createForm.campaign_name" clearable maxlength="24" type="text"
                                      style="width: 32%;"
                                      show-word-limit></el-input>
                        </el-form-item>
                        <el-form-item label="Step2: Choose App">
                            <h4 slot="label">Step2: Choose App</h4>
                            <el-select v-model="createForm.cp_app_id" :disabled="loading_apps" style="width:32%;">
                                <el-option v-for="(item,idx) in options.apps" :key="idx" :value="item.value"
                                           :label="item.label"></el-option>
                            </el-select>
                            <el-button type="text" style="margin-left: 1em;" @click="toApps">Manage apps<i
                                class="el-icon-arrow-right"></i></el-button>
                        </el-form-item>
                        <el-form-item label="Step3: Contacts">
                            <h4 slot="label">Step3: Contacts</h4>
                            <el-tabs v-model="activeTab" @tab-click="handleTabClick">
                                <el-tab-pane :label="$strings('cpsite/send/from_input')" name="first">
                                    <el-form :model="inputForm">
                                        <el-form-item v-for="(item,idx) in inputForm.numbers" :key="idx">
                                            <el-input v-model="item.value" class="max-width-160"
                                                      size="small"></el-input>
                                            <el-button size="small" @click="removeInput(item)"
                                                       style="margin-left: 1em;"><i class="el-icon-close"></i>
                                            </el-button>
                                        </el-form-item>
                                    </el-form>
                                    <el-button size="small" @click="addInput"><i class="el-icon-plus"></i></el-button>
                                </el-tab-pane>
                                <el-tab-pane :label="$strings('cpsite/send/from_address')" name="third"
                                             :disabled="vars.length > 0">
                                    <el-tooltip slot="label" class="item" effect="dark"
                                                :content="$strings('cpsite/send/from_address_forbidden')"
                                                placement="top" v-if="vars.length > 0">
                                        <span>{{ $strings('cpsite/send/from_address') }}</span>
                                    </el-tooltip>
                                    <span slot="label" v-else>{{ $strings('cpsite/send/from_address') }}</span>
                                    <AddressBook @selectGroupID="onChooseGroup"/>
                                </el-tab-pane>
                                <el-tab-pane :label="$strings('cpsite/send/from_file')" name="second">
                                    <Uploader action="/cpsite/campaign/upload/sign" @uploadSuccess="onUploadSuccess"
                                              @uploadReset="onUploadReset"/>
                                </el-tab-pane>
                            </el-tabs>
                            <el-divider></el-divider>
                            <el-checkbox v-model="createForm.dup_ignore">过滤重复</el-checkbox>
                        </el-form-item>
                        <el-form-item label="Schedule">
                            <div class="schedule-wrapper">
                                <el-switch v-model="createForm.is_schedule" style="padding-top:10px;"></el-switch>
                                <el-date-picker
                                    v-if="createForm.is_schedule"
                                    class="max-width-160"
                                    v-model="createForm.schedule_date"
                                    style="margin-left: 1em;"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    type="date"
                                    placeholder="Choose date">
                                </el-date-picker>
                                <el-time-select
                                    v-if="createForm.is_schedule"
                                    class="max-width-160"
                                    format="HH:mm"
                                    style="margin-left: 1em;"
                                    value-format="HH:mm"
                                    v-model="createForm.schedule_time"
                                    :picker-options="{start: '00:00',step: '00:15',end: '23:30'}"
                                    placeholder="Choose time">
                                </el-time-select>
                                <el-select v-model="createForm.schedule_tz" style="margin-left: 1em;"
                                           v-if="createForm.is_schedule"
                                           class="max-width-160">
                                    <el-option v-for="(val,idx) in options.tzs" :key="idx" :label="val.label"
                                               :value="val.value"></el-option>
                                </el-select>
                            </div>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="doSubmit" :loading="submitting">
                                {{ $strings('word/submit') }}
                            </el-button>
                        </el-form-item>
                    </el-form>
                </el-card>
            </el-col>
        </el-row>
        <el-dialog
            :title="$strings('cpsite/send/choose_template')"
            :visible.sync="dialogVisible"
            width="50%"
            :close-on-click-modal="false"
            :show-close="false"
            :lock-scroll="true"
            @close="handleClose">
            <div>
                <el-table :data="tplData" border max-height="300px" highlight-current-row
                          @current-change="handleCurrentChange" v-loading="templateLoading">
                    <el-table-column label="ID" width="120">
                        <template slot-scope="scope">
                            <el-radio v-model="createForm.tpl_id" :label="scope.row.tpl_id">
                                <span class="code-text">{{ scope.row.tpl_id }}</span>
                            </el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column prop="tpl_name" label="Name" width="120"></el-table-column>
                    <el-table-column prop="tpl_content" label="Name"></el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="$router.go(-1)">{{ $strings('word/back') }}</el-button>
                <el-button type="primary" @click="dialogVisible = false"
                           :disabled="createForm.tpl_id.length===0">{{ $strings('word/confirm') }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {CpSitAppRead, CpSiteCampaignCreate, CpSiteTplRead} from "@/api/cpsite/api";
import {API_STATUS_CODE, APP_STATUS, TPL_STATUS} from "@/config/config";
import {Timezones} from "@/utils/timezone";
import AddressBook from './component/addressbook'
import Uploader from "../../../components/uploader";

export default {
    name: "cpsite-send",
    components: {Uploader, AddressBook},
    data() {
        return {
            createForm: {
                campaign_name: '',      // campaign name
                tpl_id: '',             // 模板ID
                cp_app_id: '',          // app_id
                group_id: '',           // address book的ID
                is_schedule: false,     // 是否定时
                is_unicode: false,
                is_flash: false,
                dup_ignore: true,        // 忽略重复号码
                schedule_date: '',      // 定时：日期
                schedule_time: '',      // 定时：时间
                schedule_tz: 0,         // 定时：时区
                numbers: [],            // 收入的号码
                file_link: ''           // 导入的文件
            },
            loading_apps: true,
            submitting: false,
            row: {},
            options: {
                apps: [],
                tzs: Timezones,
            },
            activeTab: 'first',
            tplData: [],                        // 可用模板数据
            chooseTpl: {},                      // 选中的模板
            chooseTplIs: {},                    // 选中的模板副本
            vars: [],                           // var列表
            values: {},                         // var值
            dialogVisible: true,                // 选择模板dialog
            templateLoading: true,              // 模板加载中
            inputForm: {numbers: [{value: ''}]} // 输入手机存储
        }
    },
    computed: {
        tplCardBody() {
            return {padding: '12px'}
        }
    },
    created() {
        this.prepare();
        this.fetchTpl();
    },
    methods: {
        toApps() {
            this.$router.push('/cpsite/app');
        },
        fillNumbers() {
            this.inputForm.numbers.forEach((item) => {
                if (item.value.length > 0) {
                    this.createForm.numbers.push(item.value);
                }
            })
        },
        doSubmit() {
            this.fillNumbers()
            this.submitting = true;
            let copy = JSON.parse(JSON.stringify(this.createForm));
            copy.is_flash = 1 * copy.is_flash;
            copy.is_unicode = 1 * copy.is_unicode;
            CpSiteCampaignCreate(copy).then((resp) => {
                if (resp.data.code === API_STATUS_CODE.SUCCESS) {
                    this.$router.push('/cpsite/send-complete');
                } else {
                    this.$notify.error({title: 'ERROR', message: JSON.stringify(resp)});
                }
            }).finally(() => {
                this.submitting = false;
            });
            console.log('submit', this.createForm)
        },
        removeInput(item) {
            const index = this.inputForm.numbers.indexOf(item)
            if (index !== -1) {
                this.inputForm.numbers.splice(index, 1)
            }
            console.log(this.inputForm)
        },
        addInput() {
            this.inputForm.numbers.push({value: ''});
        },
        prepare() {
            CpSitAppRead({page: 1, size: 100, app_status: APP_STATUS.LIVING}).then((resp) => {
                this.options.apps = [];
                if (resp.data.data.total > 0) {
                    resp.data.data.rows.forEach(item => {
                        if (item.app_status === APP_STATUS.LIVING) {
                            this.options.apps.push({value: item.app_id, label: item.app_name});
                        }
                    });
                    this.loading_apps = false;
                }
            });
        },
        onUploadSuccess(fileInfo) {
            this.createForm.file_link = fileInfo.file_link;
        },
        onUploadReset() {
            this.createForm.file_link = '';
        },
        countContent() {
            return (new TextEncoder().encode(this.chooseTplIs.tpl_content)).length;
        },
        handleTabClick() {

        },
        handleClose() {
            this.chooseTplIs = JSON.parse(JSON.stringify(this.chooseTpl));
            this.extractVarsFromTemplate();
        },
        highlightOverflow() {
            if (this.countContent() > 70) {
                return 'count-over'
            }
            return '';
        },
        extractVarsFromTemplate() {
            this.vars = [];
            let content = this.chooseTpl.tpl_content;
            if (content.length === 0) {
                return;
            }
            const reg = new RegExp('{{.*?}}', 'gi');
            const vars = content.matchAll(reg);
            for (const match of vars) {
                this.vars.push(match[0].substring(2, match[0].length - 2));
            }
            if (this.vars.length > 0) {
                this.activeTab = "second";
            }
        },
        containVariable(content) {
            return /{{.*?}}/.test(content)
        },
        onChooseGroup(groupID) {
            this.createForm.group_id = groupID;
        },
        replaceContent(parameter) {
            const val = this.values[parameter];
            let copy = this.chooseTpl.tpl_content;
            if (val.length === 0) {
                this.chooseTplIs.tpl_content = copy;
                return
            }
            this.chooseTplIs.tpl_content = copy.replace('{{' + parameter + '}}', val);
            this.highlightOverflow();
        },
        fetchTpl() {
            CpSiteTplRead().then((resp) => {
                this.tplData = [];
                if (resp.data.data.total > 0) {
                    resp.data.data.rows.forEach((item) => {
                        // TODO 只考虑不带变量的，变量的后面支持
                        if (item.tpl_status === TPL_STATUS.LIVING && !this.containVariable(item.tpl_content)) {
                            this.tplData.push(item);
                        }
                    })
                }
            }).finally(() => {
                this.templateLoading = false;
            });
        },
        handleCurrentChange(val) {
            this.chooseTpl = val;
            this.createForm.tpl_id = val.tpl_id;
        }
    }
}
</script>

<style lang="scss">
.card-min {
    .el-card__header {
        padding: 0.8em 1em;
        font-size: 14px;
    }

    h4 {
        margin: 0;
    }
}
</style>

<style scoped lang="scss">
.schedule-wrapper {
    display: flex;
    flex-direction: row;
}

.tpl-body {
    line-height: normal;
}

.count-area {
    text-align: right;
    font-size: 12px;
}

.count-over {
    color: #f56c6c;
    font-weight: bold;
}
</style>